import useSEO from "@/hooks/useSEO";
import Hero from "@/components/sections/Hero";
import LogoStrip from "@/components/sections/LogoStrip";
import BrandPhilosophy from "@/components/sections/BrandPhilosophy";
import FounderHomepage from "@/components/sections/FounderHomepage";
import WhoWeServe from "@/components/sections/WhoWeServe";
import Process from "@/components/sections/Process";
import FeaturedProjects from "@/components/sections/FeaturedProjects";
import Craftsmanship from "@/components/sections/Craftsmanship";
import Capability from "@/components/sections/Capability";
import FinalCTA from "@/components/sections/FinalCTA";

export default function Home() {
  useSEO({
    title: "Auraa Designs · Hospitality Uniform Programmes Across India",
    description:
      "Auraa Designs creates hospitality uniform programmes for luxury hotels, premium restaurants and multi-property chains across India.",
    path: "/",
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <LogoStrip />
      <BrandPhilosophy />
      <FounderHomepage />
      <WhoWeServe />
      <Process />
      <FeaturedProjects />
      <Craftsmanship />
      <Capability />
      <FinalCTA />
    </div>
  );
}
